import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { Button } from '@superdispatch/ui-lab';
import { LinkAnchor } from 'shared/routing/Links';
import { LoadDTO } from '../data/LoadDTO';

interface LoadReassignDialogProps {
  load?: LoadDTO;
  type: 'reassign' | 'assign_trip';
  onClose: () => void;
  onSubmit: () => void;
}

export function LoadReassignDialog({
  load,
  type,
  onClose,
  onSubmit,
}: LoadReassignDialogProps) {
  return (
    <Dialog maxWidth="xs" fullWidth={true} open={!!load} onClose={onClose}>
      <DialogTitle disableTypography={true}>
        <Typography variant="h3">
          {type === 'reassign' ? 'Reassign' : 'Assign'}{' '}
          {load?.driver?.name || load?.driver?.email || 'Driver'}?
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography>
          This load is a part of trip{' '}
          {load?.trip?.guid ? (
            <LinkAnchor to={`/trips/view/${load.trip.guid}`}>
              {load.trip.name}
            </LinkAnchor>
          ) : (
            load?.trip?.name
          )}
          . {type === 'reassign' ? 'Reassigning' : 'Assigning'} the driver will
          remove the load from that trip.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="neutral" onClick={onClose}>
          Cancel
        </Button>

        <Button onClick={onSubmit}>
          {type === 'reassign' ? 'Reassign' : 'Assign'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
